import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildADObjectColumns } from './columns';
import { getADObjectFields } from './fields';
import { getADObjectSimpleFilters } from './simpleFilters';

/**
 * ADObject QueryEntity - bundles columns and fields
 */
export const adObjectEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'ADObject', display: 'Active Directory' },
  // secondaryLabels removed - now using separate alias entities
  buildColumns:
    buildADObjectColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getADObjectFields,
  getSimpleFilters: getADObjectSimpleFilters,
};
